import { apiPost } from '../../api'

export const saveGroup = data => {
  return apiPost({
    endpoint: 'groups/save_group',
    data: data
  })
}
